/**
 * Click handler for sidebar nav links built on `RouterLink`'s `custom`
 * slot — bind on both `@click` and `@auxclick`:
 * `@click="navigatePreservingBrowsingContext($event, href, navigate)"`.
 * (A handler-factory form would read nicer, but Vue compiles a call
 * expression in `@click` as an inline statement and discards its return
 * value — the returned handler would never run.)
 *
 * Shift- and middle-clicks open the target via a script-initiated
 * `window.open` instead of the browser's native new-tab path:
 * `<router-link>`'s `target="_blank"` route (and the browser's own
 * modified-click handling) applies an implicit `noopener`, which
 * detaches the new tab's browsing context group and breaks
 * support-session sessionStorage inheritance. A script-initiated
 * `window.open(href, '_blank')` keeps the group attached.
 *
 * Plain clicks delegate to `navigate` (which itself ignores other
 * modified clicks per vue-router's guard).
 */
export function navigatePreservingBrowsingContext(
  event: MouseEvent,
  href: string,
  navigate: (e?: MouseEvent) => unknown
) {
  if (event.shiftKey === true || event.button === 1) {
    event.preventDefault()
    event.stopPropagation()
    window.open(href, '_blank')
    return
  }
  navigate(event)
}
